import { MAX_SUGGEST_RESULTS } from '../constants';

export interface IGetRequestBodyProps {
  /** Текст для саджеста **/
  query: string;
}
export const getAddressRequestBody = ({ query }: IGetRequestBodyProps) =>
  JSON.stringify({
    query,
    count: MAX_SUGGEST_RESULTS,
  });
